<template>
  <div>
    <div class="ChatbotWelcome">
      <el-avatar class="chat-avatar" :src="chatHead"></el-avatar>
      <div class="ChatbotWelcome-content">
        <p v-html="message"></p>
      </div>
    </div>
    <div class="clear-float"></div>
  </div>
</template>

<script>

export default {
  name: 'ChatbotWelcome',
  props: {
    message: String, // 标题
  },
  data(){
    return {
      chatHead: '/static/images/chat-head.png',
    }
  },
}
</script>

<style scoped>
.ChatbotWelcome {
  position: relative;
  float: left;
  width: 85%;
  text-align: left;
  padding-left: 40px;
  margin-bottom: 5px;
}
.ChatbotWelcome-content {
  line-height: 27px;
  margin-top: 10px;
  border: 1px solid #efefef;
  padding: 0 10px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding-bottom: 10px;
}
.ChatbotWelcome-content p {
  margin-bottom: 0px;
}
</style>
